import createClass from 'create-react-class'
import React from 'react'
import i18n from 'live/services/i18n'
import FormBase from 'live/components/extensions/ui/form'
import FormGroup from 'live/components/forms/ui/form-group'
import consts from './const'
import {getTypes,get,getProps} from './types/decorator'
import Select from 'live/components/forms/ui/select'
import './types/index'
const CodeMirror = require('live/components/codemirror/codemirror').default

const ValidationMixin = require('live/components/forms/mixins/validation-mixin'),

    ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')('/rest/extension', {
        type: 'plugin-lookup-pipes',
        active: true,
        config: {
            query: '=> "A" as key, "B" as value every day',
            span: 'today',
            type:consts.allTypes[0],
            outputParams:consts.defaultOutputParams[consts.allTypes[0]],
            lookupName: '',
            lookupMacro: '',
            key: 'key',
            value: 'value',
            ...getProps('config')
        },
        fullQualifier: null,
        qualifier: null,
        status: {}
    });

export default createClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {
        properties: {
            config: {
                properties: {
                    query: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('query must not be empty')
                    },
                    span: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('span must not be empty')
                    },
                    lookupName: {
                        required: false,
                        allowEmpty: true,
                        message: i18n('lookupName must not be empty')
                    },
                    lookupMacro: {
                        required: false,
                        allowEmpty: true,
                        message: i18n('lookupMacro must not be empty')
                    },
                    key: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('event key of lookupMacro must not be empty')
                    },
                    value: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('event value of lookupMacro must not be empty')
                    },
                    __validation_dynamic_cron: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('cron must not be empty')
                    },
                }
            }
        }
    },
    setValidations(type){
        const shouldRequireLookup = type !== 'record' ? true : false

        this.validations = {
            properties: {
                config: {
                    properties: {
                        query: {
                            required: true,
                            allowEmpty: false,
                            message: i18n('query must not be empty')
                        },
                        span: {
                            required: true,
                            allowEmpty: false,
                            message: i18n('span must not be empty')
                        },
                        lookupName: {
                            required: shouldRequireLookup,
                            allowEmpty: !shouldRequireLookup,
                            message: i18n('lookupName must not be empty')
                        },
                        lookupMacro: {
                            required: shouldRequireLookup,
                            allowEmpty: !shouldRequireLookup,
                            message: i18n('lookupMacro must not be empty')
                        },
                        key: {
                            required: true,
                            allowEmpty: false,
                            message: i18n('event key of lookupMacro must not be empty')
                        },
                        value: {
                            required: true,
                            allowEmpty: false,
                            message: i18n('event value of lookupMacro must not be empty')
                        },
                        __validation_dynamic_cron: {
                            required: true,
                            allowEmpty: false,
                            message: i18n('cron must not be empty')
                        },
                    }
                }
            }
        }
    },
    _onAfterFetch: function () {
        // add validation-only config properties, which will be removed before saving.
        // handleValidation is used because it adds the properties to the config object while also
        // setting their validation state, avoiding validation error messages when saving unmodified
        // properties on existing instances
        var object = this.state.object, config = object.config

        const getProperty = (type, name) => {
            if (config[`${type}Params`] && config[`${type}Params`][name])
                return config[`${type}Params`][name]
            if (config.outputParams[name])
                return config.outputParams[name]
            return defaultOutputParams[type][name]
        }

        const properties = getTypes().reduce( (s,{type,properties}) =>({...s,[type]:properties}),{} )
        
        for (const type in properties) {
            properties[type].forEach(p => this.handleValidation({target: {
                name: `config.__validation_${type}_${p}`,
                value: getProperty(type, p)
            }}))
        }
    },
    onChangeCode: function (name, event) {
        let object = this.state.object, config = object.config;
        let value = typeof event === 'object' ? event.target.value : event;

        config[name] = value;
        this.applyObj(object);
        this.handleValidation({ target: { name: `config.${name}`, value } });
    },
    _onSuccess: function () {
        window.location.href = '#/integrations/' + this.state.object.type + '/' + this.state.object.id;
    },
    _onDelete: function () {
        window.location.href = '#/integrations/';
    },
    renderSwitch: function () {
        var object = this.state.object,config = object.config;

        const updateValidation = type =>
            this.validations.properties.config.properties = Object.keys(this.validations.properties.config.properties)
                .reduce((obj, key) => ({
                    ...obj,
                    [key]: key.startsWith('__validation_' + type)
                        ? {
                            ...this.validations.properties.config.properties[key],
                            required: true,
                            allowEmpty: false
                        }
                        : key.startsWith('__validation')
                            ? {
                                ...this.validations.properties.config.properties[key],
                                required: false,
                                allowEmpty: true
                            }
                            : this.validations.properties.config.properties[key]
                }), {})


                 const {Component:Type = () => null }  = get(config.type) || {}

                this.setValidations(config.type)

                return <Type
                    onChange={this.onChangeOutputParameter}
                    validationState={updateValidation}
                    errorsFor={this.errorsFor}
                    config={this.state.object.config}/>


    },
    onChangeOutput: function (selected) {
        var object = this.state.object,
            config = object.config;

        if (config.type) config[`${config.type}Params`] = config.outputParams;

        config.type = selected;

        if (!config[`${selected}Params`]) config.outputParams = consts.defaultOutputParams[selected];
        else config.outputParams = config[`${selected}Params`];

        this.applyObj({config: config});
        this.handleValidation({target: {name: 'config.type', value: selected}});
    },
    onChangeOutputParameter: function (name, event, isValidated, isIndexed, index) {
        let object = this.state.object, config = object.config, type = config.type;
        let value = typeof event === 'object' ? event.target.value : event;

        if (isIndexed)
            config.outputParams[name][index] = value;
        else
            config.outputParams[name] = value;

        this.applyObj(object);

        if (isValidated)
            this.handleValidation({target: {name: `config.__validation_${type}_${name}`, value}});
    },
    render: function () {
        var object = this.state.object,
            config = object.config;
            
        return <FormBase self={this}>
            <div className="form-area">
                <h3>{i18n('Config')}</h3>

                <div className="form-group">
                    <Select
                        label="Type"
                        value={config.type}
                        options={getTypes().map(({type,label = null})=> ({value:type,label:label || type}) )}
                        onChange={this.onChangeOutput}
                        validationState={this.validationState('config.type')}
                        hasFeedback help={this.errorsFor('config.type')}/>

                    <span className="help-block">
                        <p>
                            {i18n('Choose the best fit for each usage.')}
                        </p>

                        <p>
                            <strong>Dynamic Record</strong>: {i18n('DYNAMIC_RECORD_TYPE_DESCRIPTION')} <br />
                            <strong>Dynamic Live Lookup</strong>: {i18n('DYNAMIC_LIVE_LOOKUP_TYPE_DESCRIPTION')} <br />
                            <strong>Static Record</strong>: {i18n('STATIC_TYPE_DESCRIPTION')} <br />
                            <strong>Identity Lookup</strong>: {i18n('IDENTITY_TYPE_DESCRIPTION')} <br />
                        </p>
                    </span>
                </div>
                
                {
                    config.type === 'record' ? null : <div>
                        <FormGroup type="text" label={<span>{i18n('Lookup Name')}<abbr title="required">*</abbr></span>}
                            name="config.lookupName" value={config.lookupName}
                            onChange={this.handleValidation}
                            validationState={this.validationState('config.lookupName')}
                            hasFeedback help={this.errorsFor('config.lookupName')} />

                        <FormGroup type="text" label={<span>{i18n('Lookup Macro')}<abbr title="required">*</abbr></span>}
                            name="config.lookupMacro" value={config.lookupMacro}
                            onChange={this.handleValidation}
                            validationState={this.validationState('config.lookupMacro')}
                            hasFeedback help={this.errorsFor('config.lookupMacro')} />

                        </div>
                }

                <FormGroup type="text" label={<span>{i18n('Span')}<abbr title="required">*</abbr></span>}
                    name="config.span" value={config.span}
                    onChange={this.handleValidation}
                    validationState={this.validationState('config.span')}
                    hasFeedback help={this.errorsFor('config.span')} />

                <div className={`form-group has-feedback has-${this.validationState('config.query')}`}>
                    <label htmlFor="config.query" className="control-label"><span> {i18n('Query')}<abbr
                        title="required">*</abbr></span></label>
                    <CodeMirror id="config.query"
                        value={config.query}
                        onChange={(e) => this.onChangeCode('query', e)}
                        options={{
                            mode: 'pipes',
                            matchBrackets: true,
                            lineNumbers: true,
                            foldGutter: true
                        }}
                    />
                    {this.validationState('config.query') === 'error'
                        ? <div className="help-block">
                            {this.errorsFor('config.query')}
                        </div>
                        : null
                    }
                </div>
                <FormGroup type="text" label={<span>{i18n('Result key')}<abbr title="required">*</abbr></span>}
                    name="config.key" value={config.key}
                    onChange={this.handleValidation}
                    validationState={this.validationState('config.key')}
                    hasFeedback help={this.errorsFor('config.key')} />

                <FormGroup type="text" label={<span>{i18n('Result value')}<abbr title="required">*</abbr></span>}
                    name="config.value" value={config.value}
                    onChange={this.handleValidation}
                    validationState={this.validationState('config.value')}
                    hasFeedback help={this.errorsFor('config.value')} />


                {this.renderSwitch()}

            </div>
        </FormBase>
    }
});
